<div *ngIf="meeting">
  <button
    class="bg-light border border-neutral-200 rounded p-[11px] mobile:mb-7 tablet:mb-9 hover:bg-neutral-50 active:bg-neutral-200"
    title="Back to dashboard"
    (click)="back()">
    <img src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/icons/arrow_back.svg">
  </button>

  <div class="text-neutral-500 text-2 font-medium uppercase mb-4 leading-13 tracking-[1.04px]">
    Confirm Interview
  </div>
  <div class="flex justify-between">
    <div class="text-dark text-7 font-medium leading-30">{{dashboardInfo?.jobTitle}}</div>
  </div>

  <div class="bg-light rounded border-l-6 shadow-mdlight mobile:p-6 tablet:p-8 w-full mobile:mt-7 tablet:mt-[44px] border-neutral-300">
    <div class="tablet:flex tablet:justify-between mb-0 tablet:mb-7">
      <div>
        <!-- Interview Stage -->
        <div class="flex gap-2 mb-4">
          <img class="h-20" src="https://postingpanda.blob.core.windows.net/clientpublicassets/global/content/img/svg/briefcase.svg" alt="Interview Stage">
          <span class="text-4 text-dark leading-24">{{meeting.meetingTitle}}</span>
        </div>

        <!-- Location  -->
        <interview-location-widget
          [meeting]="meeting"
          [dashboardInfo]="dashboardInfo"
        ></interview-location-widget>
    </div>
    <div class="flex tablet:items-start gap-2 mobile:mt-7 tablet:mt-0">
      <a
        *ngIf="meeting.interviewType == InterviewType.REMOTE && meeting.location?.remoteUrl && isJoinButtonEnabled(meeting) && meeting.status === InterviewStatus.ACCEPTED"
        [href]="meeting.location!.remoteUrl"
        target="_blank"
        class="mobile:w-full tablet:w-[inherit] hover:bg-neutral-50 active:bg-neutral-200 disabled:border-neutral-100 disabled:cursor-not-allowed disabled:text-neutral-300 text-center whitespace-nowrap inline-block py-4 px-6 border border-neutral-200 text-[14px] text-neutral-600 rounded-base leading-18">
        Join Interview
      </a>
      <button
        type="button"
        *ngIf="meeting.interviewType == InterviewType.REMOTE && meeting.location?.remoteUrl && !isJoinButtonEnabled(meeting) && meeting.status === InterviewStatus.ACCEPTED"
        disabled
        class="mobile:w-full tablet:w-[inherit] hover:bg-neutral-50 active:bg-neutral-200 disabled:border-neutral-100 disabled:cursor-not-allowed disabled:text-neutral-300 text-center whitespace-nowrap inline-block py-4 px-6 border border-neutral-200 text-[14px] text-neutral-600 rounded-base leading-18 tooltip-subject">
        Join Interview
        <div class="tooltip whitespace-pre-line w-[200px] bottom-11 mobile:left-[-30px] tablet:left-[-40px]">
          <div class="tooltip-content text-left text-3 leading-20">
            This button will become active closer to your scheduled interview time. Please check back on the day of your interview.
          </div>
        </div>
      </button>
     
    </div>
  </div> 

  <div *ngIf="groupMeetingSlots" class="mb-7">
    <div class="text-3 leading-20 text-neutral-500 mb-4 tablet:mb-2">Available Slots:</div>
    <ng-container *ngFor="let meetingSlot of groupMeetingSlots.groupSlots; let i = index;">
      <group-slot 
        [meetingSlot]="meetingSlot" 
        [disabled]="meetingInThePast(meeting) || !meetingSlot.slotAvailable || chosenSlotIndex !== i && chosenSlotIndex !== -1" 
        (slotChosenClicked)="slotChosen(i)" 
        (cancelClicked)="slotChosen(-1)"
        (confirmationClicked)="clickConfirmInterview(meetingSlot)"></group-slot>
      <div *ngIf="(groupMeetingSlots.groupSlots.length - 1) !== i" class="my-6 border-b border-b-neutral-100"></div>      
    </ng-container>
  </div>

  <div *ngIf="interviewers && interviewers.length">
      <div class="text-neutral-500">Interviewers</div>
      <div *ngFor="let interviewer of interviewers; let last = last" class="">
        <div class="flex py-5">
          <div class="flex items-center gap-5">
            <span [style.background]="interviewer.avatarColour.backgroundColour" class="w-32 h-32 flex items-center justify-center rounded-full">
              <p class="font-medium text-center"[style.color]="interviewer.avatarColour.textColour">
                {{getInitials(interviewer)}}
              </p>
            </span>
            <span>
              <p class="text-4 text-dark leading-24">{{interviewer.firstName}} {{interviewer.lastName}}</p>
              <p class="text-4 text-neutral-500 leading-24" *ngIf="interviewer.jobTitle">{{interviewer.jobTitle}}</p>
            </span>
          </div>
        </div>
        <hr class="ml-10 text-neutral-100" *ngIf="!last" />
      </div>
    </div>

    <interview-location-map-widget
      [meeting]="meeting"
    ></interview-location-map-widget>
</div>

<decline-interview-widget
  *ngIf="!meetingInThePast(meeting)"
  [meeting]="meeting"
  (onDeclineInterviewClicked)="declineInterview($event)"
></decline-interview-widget>
</div>
